import { TypeChecker } from '@attain-apps/type-guards'

/**
 * A variable resolved from the request, allowed only in condition values.
 */
export type PrincipalVariable = (typeof PrincipalVariable.ALL)[number]
export namespace PrincipalVariable {
  export const ALL = ['${principal.id}'] as const
  export const isPrincipalVariable = TypeChecker.Factory.oneOf(ALL)
}

/** A literal, or a variable resolved from the request */
export type Value = string | PrincipalVariable

/** Exactly one operator and its operand */
export type Clause =
  | { readonly equals: Value }
  | { readonly in: readonly Value[] }
  | { readonly notIn: readonly Value[] }
